import script from "./CountryRegionInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CountryRegionInput.vue?vue&type=script&setup=true&lang=ts"

export default script